.container {
  display: flex;
  gap: 0.4rem;
  align-items: center;
  color: var(--color-grayscale-white);

  & svg {
    color: var(--color-grayscale-manatee);
  }
}
